import React from "react";

function InfoSection({ title, description }) {
  return (
    <div className="flex flex-col">
      <h1 className="text-white leading-[1.15] sm:leading-[1.1] mb-5 sm:mb-1 text-[2.5rem] font-semibold">
        {title}
      </h1>
      {description && (
        <p className="text-white text-[1rem] ml-[0.1rem]">{description}</p>
      )}
    </div>
  );
}

export default InfoSection;
